import api from "../pages/AxiosFetchData"
import React,{useState,useEffect,useCallback} from "react"
import { useNavigate } from "react-router-dom"
import ConfirmationButton from '../components/ConfirmationButton'
import Helper from "../pages/Helper"
import AxiosFetchData from "../pages/AxiosFetchData"
export const usePaymentHook = () =>{
    const [rows,setRows] = useState([])
    const [typeError,setTypeError] = useState('')
    const [message,setmessage] = useState('')
    const [roleAccess,setRoleAccess] =  useState({})
    const [role,setRole] =  useState('')
    const [confirmStatusOpen,setConfirmStatusOpen] = useState(false)
    const [seletedOptionsCustomer,setSeletedOptionsCustomer] =  useState({label:"ALL - ALL CUSTOMER", value:"ALL"})
    const [data,setData] = useState(null)
    const [action,setAction] = useState('ADD')
    const [confirmJournalOpen,setConfirmJournalOpen] = useState(false)
    const [journalrows,setJournalrows] = useState([])
    const [startDate,setStartDate] = useState(null)
    const [endDate,setEndDate] = useState(null)
    const navigate = useNavigate()

    const FetchData = useCallback(async() =>{
        try{
            let response = await api.get(`getPayment/${seletedOptionsCustomer.value}`).refreshToken(navigate,"payment");
            setRoleAccess(response.roleaccess)
            setRole(response.decode.role)
           
            let newResponse =  response.data.map((row, index) => ({
                ...row,
                  rowNumber: index + 1, 
            }));
 
            setRows(newResponse)
          
        }catch(e){
            setTypeError('errorLog')
            setmessage(e.message)
        }
    },[seletedOptionsCustomer])

    const FetchJournalData = useCallback(async() =>{
        try{
            let data = {
                customer_id : seletedOptionsCustomer.value,
                start_date: startDate,
                end_date: endDate
            }
            let response = await api.post(`getJournal`,data).refreshToken(navigate,"payment");
           
            response =  response.data.map((row, index) => ({
                ...row,
                  rowNumber: index + 1, 
            }));
            setJournalrows(response)
          
        }catch(e){
            setTypeError('errorLog')
            setmessage(e.message)
        }
    },[seletedOptionsCustomer,startDate,endDate])

    useEffect(()=>{
        FetchData();
        FetchJournalData();
    },[FetchData, FetchJournalData])

    
    const handleDelete = async (id) => {
        try{
            const response = await AxiosFetchData.delete(`deletePayment/${id}`).refreshToken(navigate,"payment")
            setmessage(response.data)
            await FetchData()
            await FetchJournalData()
        }catch(err){
            setmessage(err.message)
        }
    }
 
    const handleSelectedCustomer = (option) => {
       setSeletedOptionsCustomer(option)
    }

    const AddProjectData = () => {
        setAction("ADD")
        setConfirmStatusOpen(true)
    }

    const journalcolumns = [
        { field: 'tanggal', headerName: 'Date.', width: 110  ,headerClassName: 'super-app-theme--header'},
        { field: 'kode', headerName: 'Description.', width: 350,headerClassName: 'super-app-theme--header' },
        { field: 'debit', headerName: 'Debit.', width: 150, valueGetter: (value) => {
            return value.row.debit == 0 ? ''  : Helper.formatAsCurrency(value.row.debit);
        },headerClassName: 'super-app-theme--header'},
        { field: 'debitpph', headerName: 'Debit(PPh).', width: 150, valueGetter: (value) => {
            return value.row.debit == 0 ? ''  : Helper.formatAsCurrency(value.row.debitpph);
        },headerClassName: 'super-app-theme--header'},
        { field: 'debitppn', headerName: 'Debit(PPn).', width: 150, valueGetter: (value) => {
            return value.row.debit == 0 ? ''  : Helper.formatAsCurrency(value.row.debitppn);
        }, cellClassName: 'super-app-theme--debit',headerClassName: 'super-app-theme--header'},
        
        { field: 'credit', headerName: 'Credit.', width: 150, valueGetter: (value) => {
            return value.row.credit == 0 ? '' : Helper.formatAsCurrency(value.row.credit);
        } , cellClassName: 'super-app-theme--credit',headerClassName: 'super-app-theme--header'},
        { field: 'balance', headerName: 'Balance.', valueGetter: (value) => {
            return Helper.formatAsCurrency(value.row.balance);
        } , cellClassName: 'super-app-theme--balance',headerClassName: 'super-app-theme--header' },
    ]

    const columns = [
            { field: 'rowNumber', headerName: 'No.', width: 80 },
            { field: 'payment_code', headerName: 'Code', width: 200 },
            { field: 'amount', headerName: 'Amount', width: 170, valueGetter: (value) => {
               return Helper.formatAsCurrency(value.row.amount);
              } },
            { field: 'payment_date', headerName: 'Payment Date', width: 200 },
            { field: 'paymentname', headerName: 'Payment Method', width: 200 },
            { field: 'name', headerName: 'Customer', width: 250 },
            { field: 'kode', headerName: 'Invoice No', width: 250 },
            
              {
                field: 'actions',
                headerName: 'Actions',
                width: 150,
                renderCell: (params) => (
                  <>
                   {/* {(params.row.kode.toUpperCase() !== 'SUPERADMIN' ||  role.toUpperCase() =='SUPERADMIN') && ( */}
                   
                     <button
                      onClick={() => {
                        setConfirmStatusOpen(true)
                        setAction('EDIT')
                        setData(params.row)
                      }} // Pass the project ID to the edit function
                      className="btn btn-primary mr-2"
                      disabled={!roleAccess.UPDATE}
                    >
                      Edit
                    </button>
               
                  {/* {(params.row.kode.toUpperCase() !== 'SUPERADMIN'  || role.toUpperCase() =='SUPERADMIN') && ( */}
               
                  <ConfirmationButton classname='btn btn-danger' text="Do you want delete this data?" type="button" disabled={!roleAccess.DELETE} onClick={() => handleDelete(params.row.payment_code)}>
                        Delete 
                  </ConfirmationButton>
                
                  </>
                ),
            },
        ];

        const HandleSearch = (startDate,endDate) =>{
            setStartDate(startDate)
            setEndDate(endDate)
        }

        return {columns,rows,message,setmessage,typeError,setTypeError, confirmStatusOpen , setConfirmStatusOpen, roleAccess,AddProjectData, seletedOptionsCustomer,handleSelectedCustomer,FetchData,data,action,journalcolumns,journalrows,confirmJournalOpen,setConfirmJournalOpen,HandleSearch,FetchJournalData}
}